document.addEventListener('DOMContentLoaded', function () {
  const variantSelectors = document.querySelector('#original-version');
  const productJson = document.querySelector('#v2pdp-json');
  if (!variantSelectors || !productJson) return;

  const variantJson = JSON.parse(productJson.textContent).variants;
  
  const isRadios = variantSelectors.querySelectorAll('fieldset').length > 0;
  const fieldsets = isRadios
    ? Array.from(variantSelectors.querySelectorAll('fieldset'))
    : Array.from(variantSelectors.querySelectorAll('.product-form__input--dropdown'));
  const adapter = isRadios ? {
    getSelectedValue: (fieldset) => fieldset.querySelector('input:checked').value,
    getOptions:       (fieldset) => fieldset.querySelectorAll('input'),
    setVisibility:    (input, visible) => {
      const label = input.closest('fieldset').querySelector(`label[for="${input.id}"]`);
      if (label) label.style.display = visible ? "" : "none";
    },
    getChecked:       (fieldset) => fieldset.querySelector('input:checked'),
    selectFirstValid: (fieldset) => {
      const firstValid = fieldset.querySelector('input:not(:disabled)');
      if (firstValid) {
        firstValid.checked = true;
        firstValid.dispatchEvent(new Event('change', { bubbles: false }));
        return true;
      }
      return false;
    },
  } : {
    getSelectedValue: (fieldset) => fieldset.querySelector('select').value,
    getOptions:       (fieldset) => fieldset.querySelectorAll('option'),
    setVisibility:    (input, visible) => { input.hidden = !visible; },
    getChecked:       (fieldset) => fieldset.querySelector('option:checked'),
    selectFirstValid: (fieldset) => {
      const firstValid = fieldset.querySelector('option:not(:disabled)');
      if (firstValid) { firstValid.selected = true; return true; }
      return false;
    },
  };

  rebuildOptions();
  variantSelectors.querySelector('[data-lens-fieldset]')?.style.removeProperty('visibility');
  variantSelectors.addEventListener('change', rebuildOptions);

  function isValidCombo(selectedOptions, optionLevel, testOptionValue) {
    const keys = ['option1', 'option2', 'option3'];
    const values = [...selectedOptions.slice(0, optionLevel), testOptionValue];
    return variantJson.some(v => values.every((val, i) => v[keys[i]] == val));
  }

  function rebuildOptions() {
    const selectedOptions = fieldsets.map((fieldset) => adapter.getSelectedValue(fieldset));

    for (let optionLevel = 1; optionLevel < fieldsets.length; optionLevel++) {
      adapter.getOptions(fieldsets[optionLevel]).forEach(input => {
        const isValid = isValidCombo(selectedOptions, optionLevel, input.value);
        input.disabled = !isValid;
        adapter.setVisibility(input, isValid);
      });
      if (adapter.getChecked(fieldsets[optionLevel]).disabled &&
          adapter.selectFirstValid(fieldsets[optionLevel])) {
        variantSelectors.dispatchEvent(new Event('change', { bubbles: true }));
        break;
      }
    }
  }
});
